import React, { FC } from "react";
import GenericInformationStep from "../GenericInformationStep/GenericInformationStep";

const DoneStep: FC = () => {
   return <GenericInformationStep />;
};

export default DoneStep;
